const SDK_VERSION = '7.81.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
